import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { firebaseConfig } from "./config";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();
const AppleProvider = new OAuthProvider("apple.com");

AppleProvider.addScope("email");
AppleProvider.addScope("name");

AppleProvider.setCustomParameters({
  // Localize the Apple authentication screen in Israel.
  locale: "he",
});

export { auth, googleAuthProvider, AppleProvider };
